<template>
  <div>
    <!-- A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
<div
      :id="field.temp_prop.paper_size==0?field.temp_prop.orientation==0?'a4-standard-portrait-page':'a4-standard-landscape-page':field.temp_prop.paper_size==1?field.temp_prop.orientation==0?'a5-standard-portrait-page':'a5-standard-landscape-page':''"
      style="background: white;display: block;margin: 0 auto;box-shadow: 0 0 0.2cm rgba(0, 0, 0, 0.13);"
    
    >
      <div
        class="print-template"
        :style="{'font-size':(field.temp_prop.font_size||8)+'pt','color':field.temp_prop.hasOwnProperty('font_color')?field.temp_prop.font_color.hex:'#000','background':field.temp_prop.hasOwnProperty('bg_color')&&field.temp_prop.bg_color.show?field.temp_prop.bg_color.value.hex:'#fff'}"
      > 
      <div
          class="invoice-header-block"
          :style="{'height':field.temp_prop.margin_top+'in','background':field.header_prop.is_header_bg_color==1?field.header_prop.header_bg_color.hex:'#fff'}"
        ></div>
        <!-- Body -->
        <div
          class="invoice-content-layout"
          :style="{'padding-right':field.temp_prop.margin_right+'in','padding-left':field.temp_prop.margin_left+'in'}"
        >
            <div>
              <!-- Max width for Logo Block -->

              <!-- Logo Image -->
              <img
                v-if="field.header_prop.show_logo&&imageSrc!=''"
                :src="imageSrc"
                :style="{'width':field.header_prop.logo_width+'px'}"
                style="max-width:300px;max-height:183.05px;height:auto;"
              />
              <img
                v-if="field.header_prop.show_logo&&imageSrc==''"
                src="@/assets/logo/Shanki-logo.png"
                :style="{'width':field.header_prop.logo_width+'px'}"
                style="max-width:300px;max-height:183.05px;height:auto;"
              />
            </div>
           <div class="invoice-first-block" style="display:flex;justify-content: space-between;">
             
            <!-- Organization Details -->
            <div>
              <div
                v-if="field.header_prop.show_org_name"
                :style="{'color':field.header_prop.org_name_color.hex,'font-size':field.header_prop.org_name_size+'pt'}"
                style="margin-bottom:1px;font-weight:500;"
              >Shanki Systems India Pvt Ltd</div>

                 <div
                v-if="field.header_prop.show_org_addr"
                class="custom-invoice-address"
                :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
              >
                <p>JKR Tower</p>
                <p>5/4 Moonlight Garden</p>
                <p>Coimbatore Tamil Nadu</p>
                <p>India 641048</p>
                <p>Mail: admin@shanki.com</p>
                <p>{{field.header_prop.phone}}: 76639488488</p>
                <p style="margin-bottom:0px;">GSTIN: 12ASDF12345A1Z0</p>
              </div>
            </div>
            <div v-if="field.header_prop.show_status_stamp">
              <span
                class="stamp is-approved"
              >APPROVED</span>
            </div>
             <div class="invoice-details">
                              <!--  invoice details -->
           <h5
            v-if="field.header_prop.show_doc_title"
            :style="{'font-size':field.header_prop.doc_title_size+'pt','color':field.header_prop.doc_title_color.hex}"
            style="margin-bottom:10px !important"
            class="text-center invoice-top-heading"
          >{{field.header_prop.doc_title}}</h5>
              <table class="float-right invoice-details">
              <tbody>
              <tr class="text-right pr-0 pb-0 pt-0">
              <td
              style="font-size:8pt"
              class="fw-semi-bold pb-0 pt-0 pr-0"
              >Deposit: RET001</td>
              </tr>
              
              <tr class="text-right pr-0 pb-0 pt-0">
              <td class="fw-semi-bold pb-0 pt-4 pr-0"   style="font-size:8pt">Balance Due</td>
              </tr>
              <tr>
              <td
              class="fw-semi-bold pb-0 pt-0 pr-0 text-right"
              >{{orgCurrencySymbol}} 500</td>
              </tr>
              </tbody>
              </table>
              </div>
            <!-- Organization Logo -->
        
          </div>
         
           <div style="border-top:1px solid #ededed;margin-bottom:5px;"></div>
          <div class="invoice-second-block" style="display:flow-root">
          <div style="display:flex;justify-content: space-between;margin-top:13px !important;margin-bottom:15px !important">
                          <!--  organization detail -->
                      <div v-if="field.header_prop.doc_bill_to.show">
                <div
                  style="margin-bottom:1px;font-weight:500;word-break: break-word !important;width:180px !important',font-size:8pt"
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                >{{field.header_prop.doc_bill_to.label}}</div>
                <div
                  :style="{'font-size':field.header_prop.cus_name_size+'pt','color':field.header_prop.cus_name_color.hex}"
                  style="margin-bottom:1px;font-weight:500;word-break: break-word !important"
                >Shanki Systems India Pvt Ltd</div>

                <div class="custom-invoice-address" style="word-break: break-word !important">
                  <p>JKR Tower</p>
                  <p>5/4 Moonlight Garden</p>
                  <p>Coimbatore Tamil Nadu</p>
                  <p>India 641048</p>
                  <p>Ph: 76639488488</p>
                  <p>GSTIN: 12ASDF12345A1Z0</p>
                </div>
              </div>
               <div style="padding-top:20px !important">
                   <table class="custom-invoice-details-table">
                      <tbody>
                    <tr v-if="field.header_prop.doc_date.show">
                      <td
                        style="word-break: break-word !important,font-size:8pt"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_date.label}}:</td>
                      <td
                        class="text-right"
                        style="word-break: break-word !important"
                       
                      >{{getDateFormat(new Date())}}</td>
                    </tr>
                     <tr v-if="field.header_prop.doc_ref_no.show">
                      <td
                        style="word-break: break-word !important,font-size:8pt"
                        class="text-left semi-bold"
                        :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                      >{{field.header_prop.doc_ref_no.label}}:</td>
                      <td class="text-right" style="word-break: break-word !important">TN234556</td>
                    </tr>
                        </tbody>
                     </table>
          </div>
          </div>
           </div>
                       <div class="invoice-fifth-block" style="margin-top:15px;">
            <table
              style="width:100%"
              :style="{'border-bottom':field.inv_details.layout.table_border.show+'px'+' solid '+field.inv_details.layout.table_border.value.hex}"
            >
                 <thead
                class="semi-bold"
                :style="{'background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#535871','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}"
                style="word-break:break-word"
              >
                <th
                  v-if="field.item_prop.label.item_no.show"
                  :style="{'width':field.item_prop.label.item_no.width+'%','background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#535871','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}"
                  class="text-right semi-bold"
                  style="word-break: break-word !important"
                >{{field.item_prop.label.item_no.label}}</th>
                <th
                  :style="{'width':(field.item_prop.label.desc.width)+'%','background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#535871','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}"
                  class="text-left semi-bold pl-4"
                  style="word-break: break-word !important"
                >{{field.item_prop.label.desc.label}}</th>
                <th
                  :style="{'width':field.item_prop.label.amt.width+'%','background':field.item_prop.layout.bg_color.show?field.item_prop.layout.bg_color.value.hex:'#535871','color':field.item_prop.layout.header_font_color.hex,'font-size':field.item_prop.layout.header_font_size+'pt'}"
                  class="text-right semi-bold"
                  style="word-break: break-word !important"
                >{{field.item_prop.label.amt.label}}</th>
              </thead>
              <tbody
                 :style="{'font-size':(field.item_prop.layout.item_row_font_size||8)+'pt','background':field.item_prop.layout.hasOwnProperty('item_row_bg_color')&&field.item_prop.layout.bg_color.show?field.item_prop.layout.item_row_bg_color.value.hex:'#fff'}"
              >
                <tr>
                  <td
                     :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'color':field.item_prop.layout.hasOwnProperty('item_row_font_color')?field.item_prop.layout.item_row_font_color.hex:'#000'}"
                    v-if="field.item_prop.label.item_no.show"
                    class="text-right"
                    style="vertical-align:top"
                  >1</td>
                  <td
                    class="text-left pl-4"
                     :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'color':field.item_prop.layout.item_font_color.hex}"
                  >
                  
                    <span
                      v-if="field.item_prop.label.desc.show"
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                       style="display:block;word-break:break-word"
                    >Bournvita,, is a brand of malted and chocolate malt drink mixes manufactured by Cadburys.</span>
                  
                  </td>
                
                  <td
                    class="text-right"
                     :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'color':field.item_prop.layout.hasOwnProperty('item_row_font_color')?field.item_prop.layout.item_row_font_color.hex:'#000'}"
                  >
                   
                   100
                  </td>
                </tr>
                <tr>
                  <td
                       :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'color':field.item_prop.layout.hasOwnProperty('item_row_font_color')?field.item_prop.layout.item_row_font_color.hex:'#000'}"
                    v-if="field.item_prop.label.item_no.show"
                    class="text-right"
                    style="vertical-align:top"
                  >2</td>
                  <td
                    class="text-left pl-4"
                   :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'color':field.item_prop.layout.item_font_color.hex}"
                  >
                  
                    <span
                      v-if="field.item_prop.label.desc.show"
                      :style="{'font-size':field.item_prop.layout.item_font_size+'pt','color':field.item_prop.layout.item_font_color.hex}"
                       style="display:block;word-break:break-word"
                    >Bournvita,, is a brand of malted and chocolate malt drink mixes manufactured by Cadburys.</span>
                  
                  </td>
                
                  <td
                    class="text-right"
                     :style="{'border-bottom':field.item_prop.layout.table_border.show+'px'+' solid '+field.item_prop.layout.table_border.value.hex,'color':field.item_prop.layout.hasOwnProperty('item_row_font_color')?field.item_prop.layout.item_row_font_color.hex:'#000'}"
                  >
                   
                   200
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
                  <div
            v-if="field.total_prop.label.show_total_sec"
            class="invoice-sixth-block"
            style="display: flow-root;padding-top:23px !important"
          >
            <table class="custom-invoice-total-table float-right" style="width:100%;">
              <tbody>
                <tr>
                  <td
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >{{field.total_prop.label.total}}</td>
                  <td
                    style="width:150px"
                    class="text-right semi-bold"
                    :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                  >
                    <span
                      :class="{'float-right':field.total_prop.label.currency_syb==2}"
                    >{{orgCurrencySymbol}}</span> 300
                  </td>
                </tr>
                <template
                  v-if="field.total_prop.label.show_pay_detail"
                >
                  <tr style="background:#fff !important;">
                    <td
                      class="text-right"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;"
                    >{{field.total_prop.label.pay_made}}</td>

                    <td
                      class="text-right text-danger"
                      :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      style="font-style:italic;width:150px;color:#f55d5d!important"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{orgCurrencySymbol}}</span> (-) 100
                    </td>
                  </tr>
                   <tr>
                    <td
                      style="font-style:italic;"
                        :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      class="text-right"
                    >{{field.total_prop.label.refund}}</td>
                    <td
                      style="font-style:italic;width:150px"
                       :style="{'background':field.total_prop.layout.total_bg_color.value.hex,'color':field.total_prop.layout.total_font_color.hex,'font-size':(field.total_prop.layout.total_font_size||7)+'pt'}"
                      class="text-right"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{orgCurrencySymbol}}</span> (+) 100
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="font-style:italic;"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                      class="text-right"
                    >{{field.total_prop.label.bal_due}}</td>
                    <td
                      style="font-style:italic;width:150px"
                      :style="{'font-size':field.total_prop.layout.due_font_size+'pt','color':field.total_prop.layout.due_font_color.hex,'background-color':field.total_prop.layout.due_bg_color.show==1?field.total_prop.layout.due_bg_color.value.hex:''}"
                      class="text-right"
                    >
                      <span
                        :class="{'float-right':field.total_prop.label.currency_syb==2}"
                      >{{orgCurrencySymbol}}</span> 200
                    </td>
                  </tr>
                  
                  
                </template>
              </tbody>
            </table>
          </div>
            <div class="invoice-seventh-block" style="padding-top:20px !important">
              <div
                v-if="field.total_prop.label.show_amt_wrd"
                class="text-left semi-bold"
                style="margin-top:10px !important"
              >Total Amount (in words) : Rupees Two Hundred  Only</div>
              <div style="border-top:1px solid #ededed;margin-bottom:2px;"></div>
              <div class="text-right" :style="{'font-size':6+'pt'}">
                <i>E. & O.E</i>
              </div>
            </div>
     <div class="invoice-eigth-block" style="display: flow-root;margin-top:22px !important" >
              <div class="signature-block">
               <div class="float-left" v-if="field.footer_prop.signature.show">
                  <div
                    class="semi-bold text-right mb-2"
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                    style="word-break:break-word"
                  >{{field.footer_prop.signature.label}}</div>
                  <hr style="border-color:#000;margin-bottom:0px;margin-top: 1.5rem" />
                  <div
                    class="text-left"
                    style="word-break:break-word"
                  >{{field.footer_prop.signature.name}}</div>
                </div>

                <div
                   class="float-right"
                  v-if="field.footer_prop.hasOwnProperty('add_signature')&&field.footer_prop.add_signature.show"
                >
                  <div
                    class="semi-bold text-right mb-2"
                    :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                    style="word-break:break-word"
                  >{{field.footer_prop.add_signature.label}}</div>
                  <hr style="border-color:#000;margin-bottom:0px;margin-top: 1.5rem" />
                  <div
                    class="text-left"
                    style="word-break:break-word"
                  >{{field.footer_prop.add_signature.name}}</div>
                </div>

              </div>
            </div>
            <!--End of  Eigth Block  -->

            <!-- Ninth Block -->
          <div class="invoice-ninth-block" v-if="field.footer_prop.show_term_con" style="padding-top:40px !important">
              <div
                class="terms-conditions"
                :style="{'font-size':field.footer_prop.term_font_size+'pt'}"
              >
                <div
                  class="semi-bold text-left"
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                >{{field.footer_prop.term_label}}</div>
                <div
                  style="word-break: break-word;white-space:pre"
                >Looking forward for your business</div>
              </div>
            </div>
            <!--End of Ninth Block -->
            <!-- Tenth Block -->
         <div class="invoice-tenth-block">
              <div class="invoice-notes">
                <div
                  class="text-center"
                  :style="{'color':field.temp_prop.hasOwnProperty('label_color')?field.temp_prop.label_color.hex:'#000'}"
                >{{field.footer_prop.note_label||''}}</div>
                <div
                  :style="{'font-size':field.footer_prop.note_font_size+'pt'}"
                  class="text-center"
                >Looking forward for your business</div>
              </div>
            </div>
        </div>       
        <div
          class="invoice-footer-block"
          :style="{'height':field.temp_prop.margin_bottom+'in','background':field.footer_prop.bg_color.show==1?field.footer_prop.bg_color.value.hex:'#fff','color':field.footer_prop.hasOwnProperty('footer_color')?field.footer_prop.footer_color.hex:'#000','font-size':(field.footer_prop.footer_font_size||7)+'pt'}"
        ></div>
      
      </div>
    </div>
    <!-- End of A4 A5 STANDARD (LANDSCAPE, PORTRAIT) -->
  </div>
</template>
<script>
import { EventBus } from "@/event-bus.js"; // call bus event to access child component method from parent component
import { mapGetters } from "vuex";
export default {
  props: ["list", "id"],
  data() {
    return {
      field: JSON.parse(JSON.stringify(this.list)),
      imageSrc: ""
    };
  },
  methods: {
    preview(eve) {
      this.field = JSON.parse(JSON.stringify(eve));
    }
  },
  created() {
    this.imageSrc =
      this.org_details.org_logo != null && this.org_details.org_logo != ""
        ? `data:image/jpeg;base64,` + this.org_details.org_logo
        : "";
  },
  mounted() {
    EventBus.$on("preview", this.preview); // to trigger the method from parentcomponent
  },
  computed: {
    // mix this into the outer object with the object spread operator
    ...mapGetters(["org_details", "inv_settings_details", "orgCurrencySymbol"])
  }
};
</script>



<style lang="scss" scoped>
// A4 STANDARD PORTRAIT CSS
// Bootstrap class
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.text-right {
  text-align: right;
}
.float-left {
  float: left;
}
.float-right {
  float: right;
}
.semi-bold {
  font-weight: 500;
}
.bold {
  font-weight: 700;
}
//Custom css
//A4 standard portrait
#a4-standard-portrait-page {
  width: 21cm;
  min-height: fit-content;
}
//A4 standard landscape //A4 spreadsheet landscape
#a4-standard-landscape-page {
  width: 29.7cm;
  min-height: fit-content;
}
//A5 standard portrait
#a5-standard-portrait-page {
  width: 14.8cm;
  min-height: fit-content;
}
//A5 spreadsheet portrait
#a5-standard-landscape-page {
  width: 21cm;
  min-height: fit-content;
}

#a4-standard-portrait-page .print-template {
  zoom: 115%;
}
#a4-standard-landscape-page .invoice-content-layout {
  zoom: 130%;
}

#a5-standard-landscape-page .print-template,
#a4-standard-landscape-page .print-template {
  zoom: 80%;
}

.invoice-top-heading {
  margin-bottom: 30px;
}
.custom-invoice-address p {
  margin-bottom: 1px !important;
  font-size: 8pt;
}
.custom-invoice-address {
  margin-bottom: 5px;
}
table.custom-invoice-details-table > tbody > tr > td {
  padding: 1px !important;
}
table.custom-invoice-total-table.float-right > tbody > tr > td {
  padding: 2px !important;
}
table.shipping-details-table,
table.custom-invoice-line-item-table {
  border-collapse: collapse;
}
table.shipping-details-table td {
  border: 1px solid #ededed;
  padding: 3px !important;
}
table.custom-invoice-line-item-table thead > th {
  padding: 6px;
}
table.custom-invoice-line-item-table tbody > tr > td {
  padding: 8px !important;
}
.signature-block {
  margin-top: 60px;
}
.terms-conditions {
  width: 100%;
  margin-top: 20px;
  margin-bottom: 20px;
}
.label-invoice-tag {
  width: 100px;
}
</style>
